import { combineReducers } from 'redux'
import uiFlags from './uiFlags'

export default combineReducers({
  uiFlags,
})
